module.exports = __webpack_public_path__ + "static/media/Junitta-BW55G.a5fe5d4f.otf";